import { Link } from "react-router-dom";
import { categoryList } from "@/mocks/categories";

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-12">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
        {categoryList.map((cat) => (
          <Link
            key={cat.type}
            to={`/category/${cat.type}`}
            className="group relative flex h-40 overflow-hidden rounded-lg border border-background-200/70 md:h-44"
          >
            <img
              src={cat.image}
              alt={`${cat.label}分类入口`}
              title={`${cat.label} - 91av视频影视分类`}
              className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/50 to-foreground-950/10" />
            <div className="relative flex h-full flex-col justify-center px-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className={`${cat.icon} text-2xl`} />
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold text-background-50">{cat.label}</h3>
              <p className="mt-1 text-xs text-background-100/85">{cat.tagline}</p>
              <span className="mt-2 flex items-center gap-1 text-xs font-medium text-accent-300">
                进入专区
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}